import Loading from "@/components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";

const TVSPOS = dynamic(() => import("../../components/hardware-partners/TVS/TVSPOS"), {
    loading: () => <Loading />,
}
);

const MobileTVSPOS = dynamic(() => import("../../components/hardware-partners/TVS/MobileTVSPOS"), {
    loading: () => <Loading />,
}
);

const TvsPosSystem = ({ mobileView }) => {
    return (
        <>
            <Head>
                <title>TVS POS Machines Compatible With QueueBuster POS Software</title>
                <meta name="description" content="Discover TVS POS hardware devices compatible with our POS software. Ensure seamless integration and optimal performance for your business operations." />
                <link rel="canonical" href="https://queuebuster.co/pos-hardware-partners/tvs" />
                <link rel="alternate" href="https://queuebuster.co/pos-hardware-partners/tvs" hrefLang="en-us" />
                <meta property="og:title" content="TVS POS Hardware Devices Compatible With QueueBuster POS Software" />
                <meta property="og:description" content="Discover TVS POS hardware devices compatible with our POS software. Ensure seamless integration and optimal performance for your business operations." />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/tvs.jpg" />
                <meta property="og:url" content="https://queuebuster.co/pos-hardware-partners/tvs" />
            </Head>
            {mobileView ? <MobileTVSPOS /> : <TVSPOS />}
        </>
    )
}

export default TvsPosSystem